import { render, staticRenderFns } from "./Prefetch.vue?vue&type=template&id=6d6591a0"
import script from "./Prefetch.vue?vue&type=script&lang=js"
export * from "./Prefetch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports